<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            :main_icon="main_icon"
            :icons="icon_data"
            :load_url="load_url"
            :title="title">
    </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard';

    export default {
        name: 'OrdersToFulfilToDate',
        components: {DashboardCard},
        props: {
            width: {type:Number, default: 25},
            dataDisplay: {type:String, default: null},
        },
        data() {
            return {
                main_icon: 'fa-light fa-print',
                title: 'Fulfillment',
                load_url: '/dashboards/fulfilment/',
                icon_data: [
                    {
//                        name: 'Ready To Print',
                        name: 'Ready',
                        text_color: '#2A9D8F',
                    },
                    {
                        name: 'Printed',
                        text_color: '#264653',
                    },
                    {
                        name: 'Failed',
                        text_color: '#F4A261',
                    },
                    {
                        // this includes invalid address +
                        // Address not verified flagthis includes invalid address +
                        // Address not verified flagthis
//                        name: 'Needing Review',
                        name: 'Review',
                        text_color: '#E76F51',
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>